module.exports = __webpack_public_path__ + "assets/system.b6020d09.svg";